import React from "react";

function ShippingAddressIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="41"
      viewBox="0 0 40 41"
      fill="none"
    >
      <path
        d="M32 0.199219C36.4183 0.199219 40 3.78094 40 8.19922V32.1992C40 36.6175 36.4183 40.1992 32 40.1992H8C3.58172 40.1992 0 36.6175 0 32.1992V8.19922C0 3.78094 3.58172 0.199219 8 0.199219H32Z"
        fill="url(#paint0_linear_1418_1740)"
      />
      <path
        d="M32 0.199219C36.4183 0.199219 40 3.78094 40 8.19922V32.1992C40 36.6175 36.4183 40.1992 32 40.1992H8C3.58172 40.1992 0 36.6175 0 32.1992V8.19922C0 3.78094 3.58172 0.199219 8 0.199219H32Z"
        stroke="#E5E7EB"
      />
      <path
        d="M8.875 10.1992C7.83984 10.1992 7 11.0391 7 12.0742V24.5742C7 25.6094 7.83984 26.4492 8.875 26.4492H9.5C9.5 28.5195 11.1797 30.1992 13.25 30.1992C15.3203 30.1992 17 28.5195 17 26.4492H22C22 28.5195 23.6797 30.1992 25.75 30.1992C27.8203 30.1992 29.5 28.5195 29.5 26.4492H30.75C31.4414 26.4492 32 25.8906 32 25.1992C32 24.5078 31.4414 23.9492 30.75 23.9492V21.4492V20.1992V19.4688C30.75 18.8047 30.4883 18.168 30.0195 17.6992L27 14.6797C26.5312 14.2109 25.8945 13.9492 25.2305 13.9492H23.25V12.0742C23.25 11.0391 22.4102 10.1992 21.375 10.1992H8.875ZM23.25 16.4492H25.2305L28.25 19.4688V20.1992H23.25V16.4492ZM11.375 26.4492C11.375 25.9519 11.5725 25.475 11.9242 25.1234C12.2758 24.7718 12.7527 24.5742 13.25 24.5742C13.7473 24.5742 14.2242 24.7718 14.5758 25.1234C14.9275 25.475 15.125 25.9519 15.125 26.4492C15.125 26.9465 14.9275 27.4234 14.5758 27.775C14.2242 28.1267 13.7473 28.3242 13.25 28.3242C12.7527 28.3242 12.2758 28.1267 11.9242 27.775C11.5725 27.4234 11.375 26.9465 11.375 26.4492ZM25.75 24.5742C26.2473 24.5742 26.7242 24.7718 27.0758 25.1234C27.4275 25.475 27.625 25.9519 27.625 26.4492C27.625 26.9465 27.4275 27.4234 27.0758 27.775C26.7242 28.1267 26.2473 28.3242 25.75 28.3242C25.2527 28.3242 24.7758 28.1267 24.4242 27.775C24.0725 27.4234 23.875 26.9465 23.875 26.4492C23.875 25.9519 24.0725 25.475 24.4242 25.1234C24.7758 24.7718 25.2527 24.5742 25.75 24.5742Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1418_1740"
          x1="0"
          y1="20.1992"
          x2="40"
          y2="20.1992"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2563EB" />
          <stop offset="1" stop-color="#7C3AED" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default ShippingAddressIcon;
